import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth-context';
import type { Role } from '../../types';

type Props = { role: Role; children: ReactNode };

export function ProtectedRoute({ role, children }: Props) {
  const { state } = useAuth();
  if (state.status === 'loading') return null;
  if (state.status === 'anonymous') return <Navigate to="/" replace />;
  if (role === 'child' && state.status !== 'child') return <Navigate to="/parent" replace />;
  if (role === 'parent' && state.status !== 'parent') return <Navigate to="/child" replace />;
  return <>{children}</>;
}
